interface PageHeroProps {
  tag: string;
  titulo: string;
  tituloItalico: string;
  subtitulo: string;
  bgImage?: string;
}

export default function PageHero({ tag, titulo, tituloItalico, subtitulo, bgImage }: PageHeroProps) {
  const defaultBg = 'https://readdy.ai/api/search-image?query=dramatic%20dark%20elegant%20courtroom%20interior%20with%20atmospheric%20golden%20lighting%2C%20wooden%20furniture%20and%20polished%20marble%20floors%2C%20sophisticated%20legal%20environment%2C%20deep%20shadows%20and%20golden%20highlights%2C%20premium%20minimalist%20law%20firm%20aesthetic%2C%20high%20contrast%20moody%20photography%2C%20justice%20symbolism%2C%20dark%20navy%20blue%20deep%20tones%20with%20warm%20gold%20accents%2C%20cinematic%20quality%2C%20refined%20classical%20architecture&width=1920&height=480&seq=page-hero-mt-inner&orientation=landscape';

  return (
    <section className="relative pt-32 pb-20 flex items-center justify-center overflow-hidden min-h-[340px]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={bgImage || defaultBg}
          alt={titulo}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1829]/90 via-[#0A1829]/85 to-[#0A1829]/95"></div>
      </div>

      {/* Gold left accent */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-24 bg-gradient-to-b from-transparent via-[#B39B62] to-transparent hidden lg:block"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 text-center">
        {/* Tag */}
        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-10 bg-[#B39B62]"></span>
          <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
            {tag}
          </span>
          <span className="h-px w-10 bg-[#B39B62]"></span>
        </div>

        {/* Title */}
        <h1 className="font-serif text-4xl lg:text-6xl text-white font-light leading-[1.1] tracking-tight mb-5">
          {titulo}{' '}
          <span className="italic text-[#E9D59C]">{tituloItalico}</span>
        </h1>

        {/* Subtitle */}
        <p className="font-sans text-white/60 text-base lg:text-lg font-light leading-relaxed max-w-2xl mx-auto">
          {subtitulo}
        </p>
      </div>
    </section>
  );
}
